import Attack from '../../types/Attack/Attack';
import { SimplifiedConstraint, SimplifiedProfile, SimplifiedSelectionEntry } from '../../types/Library/LibrarySimplified';
import Unit, { unitTypes, wardMap, wardTypes } from '../../types/Unit/Unit';

function buildAttack(name: string, numModels: number, hasChampion: boolean, profile: SimplifiedProfile): Attack {
  let numAttacks = '1';
  let hitType = '6+';
  let woundType = '6+';
  let rend = 1;
  let damage = '1';
  let abilities: string[] = [];
  let rangeType = 'MELEE';

  profile.characteristics.forEach((c) => {
    switch(c.name) {
    case 'Rng':
      rangeType = 'RANGED';
      break;
    case 'Atk':
      numAttacks = c.text;
      break;
    case 'Hit':
      hitType = c.text;
      break;
    case 'Wnd':
      woundType = c.text;
      break;
    case 'Rnd':
      rend = c.text === '-' ? 0 : Number(c.text);
      break;  
    case 'Dmg':
      damage = c.text;
      break; 
    case 'Ability':
      abilities = c.text.split(',').map((s) => s.trim());
      break; 
    }
  });

  const critType = abilities.find((s) => s.includes('Crit'));
  const isCompanion = abilities.includes('Companion');
  const hasChargeDamage = abilities.includes('Charge (+1 Damage)');

  return new Attack(
    name,
    numModels,
    numAttacks,
    hitType,
    woundType,
    rend,
    damage,
    rangeType,
    critType ?? 'None',
    isCompanion,
    hasChargeDamage,
    hasChampion && !isCompanion
  );
}

function getMaxAndMin(constraints: SimplifiedConstraint[]): [number, number] {
  if(constraints.length >= 2) {
    const firstValue = Number(constraints[0].value);
    const secondValue = Number(constraints[1].value);

    if(constraints[0].type === 'min') {
      return [firstValue, secondValue];
    } 
    if(constraints[0].type === 'max' && constraints[1].type === 'max') {
      return [0, firstValue > secondValue ? firstValue : secondValue];
    }
  }

  return [0, 0];
}

export function convertToUnit(data: SimplifiedSelectionEntry): Unit {
  const name = data.name;
  const types: string[] = [];
  let wardType = 'None';
  let hasChampion = false;
  data.categoryLinks?.forEach((c) => {
    if(unitTypes.includes(c.name)) {
      types.push(c.name);
    } else if(wardTypes.includes(c.name)) {
      wardType = wardMap.get(c.name) ?? 'None';
    } else if(c.name.includes('WIZARD')) {
      types.push('WIZARD');
    } else if(c.name.includes('PRIEST')) {
      types.push('PRIEST');
    } else if(c.name === 'CHAMPION') {
      hasChampion = true;
    }
  });

  let health = 1;
  let save = '6+';
  let control = 1;

  const dataProfileIdx = data.profiles?.findIndex((p) => p.characteristics.find((c) => c.name === 'Move'));

  if(data.profiles && dataProfileIdx !== undefined) {
    health = Number(data.profiles[dataProfileIdx].characteristics[1].text);
    save = data.profiles[dataProfileIdx].characteristics[2].text;
    control = Number(data.profiles[dataProfileIdx].characteristics[3].text);
  }

  const attacks: Attack[] = [];
  let unitSize = 1;

  if(data.selectionEntries && data.selectionEntries[0]) {
    const characterEntries = data.selectionEntries[0];
    unitSize = characterEntries.constraints ? Number(characterEntries.constraints[1].value) : 1;
    
    if(characterEntries.selectionEntries) {
      characterEntries.selectionEntries.forEach((attack) => {
        let min = 1;
        //let max = 1;
        if(attack.constraints) {
          [min] = getMaxAndMin(attack.constraints);
        }
        
        const profiles = attack.profiles;

        if(profiles && profiles[0]) {
          attacks.push(buildAttack(attack.name, min * unitSize, hasChampion && min === 1, profiles[0]));
        }
      });
    }
  }

  return new Unit(
    name,
    unitSize,
    health,
    save,
    control,
    types,
    wardType,
    attacks
  );
}
